<template>
    <div id="preloader">
        <div id="status">&nbsp;</div>
    </div>

    <Menu />
    <router-view></router-view>
    <Footer />
</template>

<script>
import Menu from "./partials/Menu";
import Footer from "./partials/Footer";

export default {
    name: "App",
    components: {Footer, Menu},
    setup() {
        return {

        }
    }
}
</script>
